module.exports = __webpack_public_path__ + "static/media/5.702d7d59.svg";